import Image from 'next/image'
import Link from 'next/link'

import { AdvertiserDisclosure } from '@ui/components/Disclosure'
import { Footer } from '@ui/layout/Footer'
import { cn } from '@ui/lib/utils'

export function OfferLayout({
  className,
  childrenClassName,
  userId,
  children,
}: {
  className?: string
  childrenClassName?: string
  userId?: string | null
  children: React.ReactNode
}) {
  return (
    <>
      {/* Navbar */}
      <div className="relative top-0 z-50 bg-white shadow-sm">
        <div className="mx-auto flex h-16 max-w-2xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <div className="flex shrink-0 items-center">
            <Link
              href={userId ? '/offers?uid=' + userId : '/offers'}
              className="transition duration-150 hover:opacity-80"
            >
              <Image
                src="/img/atm-logo.svg"
                alt="ATM.com"
                width={83}
                height={52}
                className="h-8 w-auto sm:h-10"
              />
            </Link>
          </div>

          <AdvertiserDisclosure
            title="Disclosure"
            className="leading-tight md:flex-none"
          />

          {/* 
          <div className="flex items-center space-x-4">
            {isLoggedIn ? (
              <Link
                href="/dashboard"
                className="text-blueberry-700 hover:text-blueberry-800 rounded-full px-4 py-1.5 text-sm font-medium"
              >
                Dashboard
              </Link>
            ) : (
              <>
                <Link
                  href="/"
                  className="text-blueberry-700 hover:text-blueberry-800 rounded-full px-4 py-1.5 text-sm font-medium"
                >
                  Sign in
                </Link>
                <Link
                  href="/"
                  className="bg-blueberry-700 hover:bg-blueberry-600 active:bg-blueberry-800 rounded-full px-4 py-1.5 text-sm font-medium text-white transition-colors"
                >
                  Sign up
                </Link>
              </>
            )}
          </div> 
          */}
        </div>
      </div>

      {/* Main content */}
      <main className={cn('min-h-screen', className)}>
        <div className="mx-auto max-w-2xl px-4 py-6 sm:px-6 sm:py-8">
          <div className={childrenClassName}>{children}</div>
        </div>
      </main>

      <Footer />
    </>
  )
}

export default OfferLayout
